import { AiGenerateAnswerListButton } from './AiGenerateAnswerListButton';
import { AiGenerateAnswerListOverlay } from './AiGenerateAnswerListOverlay';
import { AiGenerateSingleAnswerButton } from './AiGenerateSingleAnswerButton';
import { AiGenerateSingleAnswerOverlay } from './AiGenerateSingleAnswerOverlay';
import { AiGenerateSingleSimilarAnswerButton } from './AiGenerateSingleSimilarAnswerButton';

export const AiAnswerGeneration = {
  AnswerListButton: AiGenerateAnswerListButton,
  MainAnswerButton: AiGenerateSingleAnswerButton,
  SimilarAnswerButton: AiGenerateSingleSimilarAnswerButton,
  SingleAnswerOverlay: AiGenerateSingleAnswerOverlay,
  AnswerListOverlay: AiGenerateAnswerListOverlay,
};
